module.exports = __webpack_public_path__ + "band_10.5e7fd252.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_10.png
// module id = qWo4
// module chunks = 0